// @flow
import DeactivateOperatorModalContainer from './DeactivateOperatorModalContainer';
export default DeactivateOperatorModalContainer;
